// @flow

export const UPDATE_INIT_DATA = 'UPDATE_INIT_DATA'
export const SHARED_REQUEST_SET_ID = 'SHARED_REQUEST_SET_ID'
